import { activityExport } from 'services/activitiesApi'
import { downloadCSV } from 'utils/downloadCSV'
import { jsonToCsv } from './JsonToCsvConverter'

export const onActivityCSVExport = async (
  activityIndices: string,
  entityId: string,
  vertical: string,
  filters?: string,
  sort?: string | qs.ParsedQs | string[] | qs.ParsedQs[],
  datePeriod?: { start: string; end: string },
  csvFileName?: string,
  subHeaders?: { label: string; value: string; placement: string }[],
  currencyContext?: any,
): Promise<void> => {
  try {
    const { activities, headers } = await activityExport(
      activityIndices,
      entityId,
      vertical,
      filters,
      sort,
      datePeriod,
      currencyContext,
    )

    if (subHeaders) {
      downloadCSV({ activities, headers, subHeaders }, csvFileName || 'ActivityExport')
    } else {
      const activitiesCSV = jsonToCsv(activities, headers)
      downloadCSV(activitiesCSV, csvFileName || 'ActivityExport')
    }
  } catch (error) {
    console.error('Error exporting CSV:', error)
    throw error
  }
}
